// Letter-monogram brand mark.
// IMPORTANT: We do NOT render any third-party logos (Google Ads / trademark
// compliance). We use the brand's first letter on its accent color so the chip
// is still recognizable without infringing.

export default function BrandIcon({ logoKey, name, className = "" }) {
  const display = (name || logoKey || "?").trim().charAt(0).toUpperCase();
  return (
    <span
      aria-hidden
      className={`inline-flex items-center justify-center ${className}`}
      style={{
        color: "#ffffff",
        fontFamily: '"Hanken Grotesk", Satoshi, sans-serif',
        fontWeight: 800,
        fontSize: "18px",
        letterSpacing: "-0.02em",
        textShadow: "0 1px 2px rgba(0,0,0,.35)",
        width: "100%",
        height: "100%",
      }}
    >
      {display}
    </span>
  );
}
